export class IssuePriorityFront {
    priority: string;
    priorityColor: string;
}
